import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyBoardRapidViewRoute: InvariantJiraRoute = {
	name: 'legacy-board',
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView'],
};
